export default class JournalEntry {
    id: string;
    date: string;
    eventType: string;
    eventId: string;
    transactionType: string;
    transactionId: string;
    subTransactionType: string;
    transactionAmount: string;
    createdAt: Date;
    bookingDate: Date;
    valueDate: Date;
    productId: string;
    productIssueId: string;
    productCode: string;
    productType: string;
    productSubType: string;
    debitAccount: string;
    debitAmount: string;
    creditAccount: string;
    creditAmount: string;
    notes: string;
}